import React, { useEffect, useState } from "react"

import { RefinementListProvided } from "react-instantsearch-core"
import { connectRefinementList } from "react-instantsearch-dom"

import kids from "./kids.svg"
import kidsMobile from "./kids-mobile.svg"
import { Body } from "~/components/ui"
import Checkbox from "~/components/ui/Checkbox/Checkbox"
import useAlgoliaFacets, { mergeItems } from "~/hooks/useAlgoliaFacets"
import { sortRefinementListFacetsByLabel } from "~/utils/algoliaUtils"
import { capitalizeFirstLetter } from "~/utils/string"

import css from "./CustomRefinmentList.module.scss"

type propType = RefinementListProvided & {
  baseItems: any
}

const RefinementList = ({ items, refine, createURL, baseItems }: propType) => {
  const {
    initialFacets: { vertical },
  } = useAlgoliaFacets()

  const [displayedItems, setDisplayedItems] = useState(
    mergeItems({
      activeItems: baseItems ?? items ?? [],
      inactiveItems: vertical ?? [],
    })
  )

  useEffect(() => {
    if (items.length > 0) {
      setDisplayedItems(
        mergeItems({ activeItems: items, inactiveItems: vertical ?? [] })
      )
    }
  }, [items, vertical])

  return (
    <div className={css.refinmentList}>
      {displayedItems.sort(sortRefinementListFacetsByLabel).map((item: any) => {
        const labelName =
          item.label === "light-and-fun" ? "Light & fun" : item.label
        return (
          <Checkbox
            key={item.label + item.isRefined}
            label={item.label}
            value={item.value}
            defaultChecked={item.isRefined}
            onclick={event => {
              event.preventDefault()
              refine(item.value)
              createURL(item.value)
            }}
            disabled={item.count === 0}
          >
            {item.label == "kids" ? (
              <>
                <div className={css.onlyRegular}>
                  <img
                    src={kids}
                    alt="kids"
                    className={
                      item.count === 0 ? css.logoKidsDisabled : undefined
                    }
                  />
                </div>
                <div className={css.onlyCompact}>
                  <img
                    src={kidsMobile}
                    alt="kids"
                    className={
                      item.count === 0 ? css.logoKidsDisabled : undefined
                    }
                  />
                </div>
              </>
            ) : (
              <Body
                variant="body2"
                semiBold
                color={item.count === 0 ? "gray4" : "black"}
              >
                {capitalizeFirstLetter(labelName)}
              </Body>
            )}
          </Checkbox>
        )
      })}
    </div>
  )
}

const CustomRefinmentList = connectRefinementList<propType>(RefinementList)

export default CustomRefinmentList
